module.exports = __webpack_public_path__ + "img/CDNX-Logo_dark.32cf96.svg";